import { Component, output } from '@angular/core';
import { WorkspaceApiProviderService } from '@core/api';
import { catchError, of, tap } from 'rxjs';
import { ModalService } from 'src/app/project/components/modal/modal.service';
import { PromptService } from 'src/app/project/components/prompt/prompt.service';
import { TranslationPipe } from 'src/app/project/features/translate/translation.pipe';
import { TSiteResponse } from 'src/app/project/modules/workspace/site-response.model';
import { ActiveService } from 'src/app/project/services/active/active.service';
import { logEventInGTAG } from 'src/app/project/services/analytics/google-analytics';
import {
  EGoogleEventCategory,
  EGoogleEventSettings,
} from 'src/app/project/services/analytics/google-analytics.consts';
import { SiteSettingsPlanDeleteModalComponent } from './site-settings-plan-delete-modal/site-settings-plan-delete-modal.component';

@Component({
    selector: 'pp-site-settings-plan-delete-button',
    templateUrl: './site-settings-plan-delete-button.component.html',
    styleUrl: './site-settings-plan-delete-button.component.scss',
    standalone: false
})
export class SiteSettingsPlanDeleteButtonComponent {
  ppOnPlanDeleted = output<TSiteResponse>();

  constructor(
    private workspaceApiProviderService: WorkspaceApiProviderService,
    private modalService: ModalService,
    private promptService: PromptService,
    private translationPipe: TranslationPipe,
    private activeService: ActiveService,
  ) {}

  showDeletePlanModal(): void {
    this.modalService.setData({});

    this.modalService.showModal(SiteSettingsPlanDeleteModalComponent, {
      blur: true,
      callback: () => {
        this.deleteSitePlan();
      },
    });
  }

  deleteSitePlan(): void {
    const workspaceId = this.activeService.getActiveWorkspaceId();

    this.workspaceApiProviderService
      .deleteSitePlan(workspaceId)
      .pipe(
        tap((response) => {
          const promptText = this.translationPipe.transform('prompt_site_plan_deleted');
          this.promptService.showSuccess(promptText);

          this.ppOnPlanDeleted.emit(response);

          logEventInGTAG(EGoogleEventSettings.SETTINGS__SITE_PLAN__DELETE, {
            source: EGoogleEventCategory.SETTINGS,
          });
          this.modalService.hideModal();
        }),
        catchError(() => {
          const promptText = this.translationPipe.transform('prompt_site_plan_deleted_error');

          this.promptService.showError(promptText);
          return of();
        }),
      )
      .subscribe();
  }
}
